import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicBaseQuery } from '../badRequestHandler';

export const ludoApi = createApi({
  reducerPath: 'ludoApi',
  baseQuery: dynamicBaseQuery,
  tagTypes: ['Ludo'],
  endpoints: (builder) => ({
    getLudoInplayRounds: builder.query({
      query: () => ({
        url: '/api/dice/admin/active-games',
        method: 'GET',
      }),
      providesTags: ['Ludo'],
    }),

    getLudoRounds: builder.query({
      query: ({ game = 'ludo', page = 1, limit = 20 }) => ({
        url: `/api/ludo/admin/rounds?game=${game}&page=${page}&limit=${limit}`,
        method: 'GET',
      }),
      providesTags: ['Ludo'],
    }),

    getLudoRoundBets: builder.query({
      query: (roundId) => ({
        url: `/api/ludo/admin/round-bets?roundId=${roundId}`,
        method: 'GET',
      }),
      providesTags: ['Ludo'],
    }),

    getLudoCompletedGames: builder.query({
      query: () => ({
        url: '/api/ludo/admin/completed-games',
        method: 'GET',
      }),
      providesTags: ['Ludo'],
    }),

    getLudoCompanyReport: builder.query({
      query: ({ game, userId, fromDate, toDate }) => ({
        url: '/api/dice/admin/company-report',
        method: 'GET',
        params: { game, userId, fromDate, toDate },
      }),
      providesTags: ['Ludo'],
    }),
  }),
});

export const {
  useGetLudoInplayRoundsQuery,
  useGetLudoRoundsQuery,
  useGetLudoRoundBetsQuery,
  useGetLudoCompletedGamesQuery,
  useGetLudoCompanyReportQuery,
} = ludoApi;

export default ludoApi;
